import { LstatAnalysisWarning } from "../../../interfaces/be.interfaces";
import styles from "./styles.module.scss";

export function AnalysisLstatWarning ({warning_msg}: LstatAnalysisWarning) {
  return (<div className={styles.wisaAnalysisLstatWarning}>
    <div className={styles.wisaAnalysisLstatWarningMessage}>{warning_msg}</div>
  </div>);
}

export interface AnalysisWarningsProps {
  warnings: LstatAnalysisWarning[];
}

function AnalysisLstatWarnings ({warnings}: AnalysisWarningsProps) {
  return (
    <div className={styles.wisaAnalysisLstatWarnings}>
      {
        warnings.map((warning, index) => (
          <AnalysisLstatWarning
            key={`analysis-warning-${index}`}
            warning_name={warning.warning_name}
            warning_msg={warning.warning_msg}
          />
        ))
      }
    </div>
  );
}

export default AnalysisLstatWarnings;